
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solution-guides",
      function () {
        return require("private-next-pages/solution-guides.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solution-guides"])
      });
    }
  